import Mousetrap from 'mousetrap';
import MousetrapPause from 'mousetrap-pause';

const MousetrapWrapped = MousetrapPause(Mousetrap);
export default MousetrapWrapped;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/mousetrap.js